import { MarkupContext } from '@estimator/shared';
import { useItemCategories } from '@/api/item-categories';
import { useMarkupStore } from '@/store/markupStore';

const CONTEXTS: { value: MarkupContext; label: string; color: string }[] = [
  { value: MarkupContext.FLOOR_PLAN, label: 'Floor Plan', color: '#e8a020' },
  { value: MarkupContext.SECTION_CUT, label: 'Section Cut', color: '#60a5fa' },
  { value: MarkupContext.DETAIL, label: 'Detail', color: '#4ade80' },
  { value: MarkupContext.ELEVATION, label: 'Elevation', color: '#a78bfa' },
];

export default function ContextToolbar() {
  const { activeContext, activeItemCategoryId, setActiveContext, setActiveItemCategoryId } =
    useMarkupStore();
  const { data: categories = [] } = useItemCategories(true);

  return (
    <div
      className="flex flex-col gap-1.5 px-3 py-2 border-b"
      style={{ backgroundColor: 'var(--bg-surface)', borderColor: 'var(--border)' }}
    >
      {/* Drawing context row */}
      <div className="flex items-center gap-1.5">
        <span
          className="text-[9px] uppercase tracking-wider w-16 flex-shrink-0"
          style={{ color: 'var(--text-muted)' }}
        >
          Context
        </span>
        <div className="flex items-center gap-1 overflow-x-auto">
          {CONTEXTS.map((ctx) => {
            const isActive = activeContext === ctx.value;
            return (
              <button
                key={ctx.value}
                onClick={() => setActiveContext(ctx.value)}
                className="flex-shrink-0 px-2.5 py-0.5 rounded-md text-[10px] font-medium border transition-all duration-150 cursor-pointer"
                style={{
                  backgroundColor: isActive
                    ? `color-mix(in srgb, ${ctx.color} 20%, transparent)`
                    : 'transparent',
                  borderColor: isActive ? ctx.color : 'var(--border)',
                  color: isActive ? ctx.color : 'var(--text-muted)',
                }}
              >
                {ctx.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Item type row */}
      <div className="flex items-center gap-1.5">
        <span
          className="text-[9px] uppercase tracking-wider w-16 flex-shrink-0"
          style={{ color: 'var(--text-muted)' }}
        >
          Type
        </span>
        <div className="flex items-center gap-1 overflow-x-auto">
          {categories.map((cat) => {
            const isActive = activeItemCategoryId === cat.id;
            return (
              <button
                key={cat.id}
                onClick={() => setActiveItemCategoryId(isActive ? null : cat.id)}
                className="flex-shrink-0 px-2.5 py-0.5 rounded-full text-[10px] font-medium border transition-all duration-150 cursor-pointer"
                style={{
                  backgroundColor: isActive
                    ? `color-mix(in srgb, ${cat.color} 20%, transparent)`
                    : 'transparent',
                  borderColor: isActive ? cat.color : 'var(--border)',
                  color: isActive ? cat.color : 'var(--text-secondary)',
                  boxShadow: isActive ? `0 0 8px color-mix(in srgb, ${cat.color} 30%, transparent)` : 'none',
                }}
              >
                {cat.name}
              </button>
            );
          })}
          {categories.length === 0 && (
            <span className="text-[10px]" style={{ color: 'var(--text-muted)' }}>
              No categories configured
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
